/**
 * stores/i18nStore.ts · 语言状态
 *
 * 替代 v300/core/i18n.ts 内 module-level currentLang
 */

import { BaseStore } from './BaseStore';
import type { SupportedLanguage } from '@/constants';

interface I18nState {
  lang: SupportedLanguage;
}

function detectInitialLang(): SupportedLanguage {
  try {
    const saved = localStorage.getItem('lang');
    if (saved === 'zh' || saved === 'vi') return saved;
  } catch { /* ignore */ }
  const browser = navigator.language.toLowerCase();
  if (browser.startsWith('vi')) return 'vi';
  return 'zh';
}

class I18nStore extends BaseStore<I18nState> {
  constructor() {
    super({ lang: detectInitialLang() });
  }

  setLang(lang: SupportedLanguage): void {
    this.set({ lang });
    try { localStorage.setItem('lang', lang); } catch { /* ignore */ }
    document.documentElement.lang = lang;
    document.dispatchEvent(new CustomEvent('tn-lang-change', { detail: lang }));
  }

  toggle(): void {
    this.setLang(this.getField('lang') === 'zh' ? 'vi' : 'zh');
  }

  get currentLang(): SupportedLanguage {
    return this.getField('lang');
  }
}

export const i18nStore = new I18nStore();
